import { useState } from 'react';
import { Container, Row, Col, Modal, Image } from 'react-bootstrap';
import sala from "../../assets/images/sala.jpg";

const Beneficios = () => {
  const [showModal, setShowModal] = useState(false);

  const listaBeneficios = [
    "Alivio del dolor muscular y articular",
    "Mejora del rendimiento deportivo",
    "Reducción del estrés y la ansiedad",
    "Mejora de la circulación sanguínea",
    "Incremento de la flexibilidad y movilidad",
    "Mejora del sueño y la calidad de vida"
  ];

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center mb-8 beneficios-container">
      
      <style>{`
        .beneficio-item {
          display: flex;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #f1f3f5;
        }
        .beneficio-item:last-child {
          border-bottom: none;
        }
        .beneficio-texto {
          font-size: 1.05rem;
          color: #343a40;
          font-weight: 500;
        }
        .imagen-sala-beneficios {
          width: 100%;
          height: 100%; /* Ocupa el 100% de la altura de la columna */
          min-height: 300px; /* Evita que se haga diminuta en pantallas intermedias */
          object-fit: cover !important; /* ✅ CORREGIDO: Sin comillas. Recorta la foto perfectamente sin deformar */
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          transition: transform 0.2s ease;
        }
        .imagen-sala-beneficios:hover {
          transform: scale(1.01);
        }
      `}</style>

      <h2 className="text-center" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Masaje en Castellón</h2>
      <p className="text-center mb-4" style={{ maxWidth: '650px', color: '#6c757d' }}>
        El masaje es una de las herramientas más antiguas que tenemos para combatir dolores y mejorar el estado físico y mental. Los beneficios más notables de hacerse un masaje son:
      </p>

      <Row className="align-items-stretch w-100 mb-5 mx-auto" style={{ maxWidth: '880px' }}>
        
        {/* Lista de Beneficios */}
        <Col md={6} className="d-flex flex-column justify-content-center pe-md-4">
          <div className="py-2">
            {listaBeneficios.map((beneficio, index) => (
              <div key={index} className="beneficio-item">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="19" 
                  height="19" 
                  fill="#cbab5d" 
                  className="bi bi-check-circle-fill me-3 flex-shrink-0" 
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
                <span className="beneficio-texto">{beneficio}</span>
              </div>
            ))}
          </div>
        </Col>

        {/* Columna Derecha: Imagen que se autoajusta */}
        <Col md={6} className="d-flex mt-4 mt-md-0 ps-md-4">
          <img
            src={sala}
            alt="Sala de masajes Manus Fortis"
            className="imagen-sala-beneficios"
            onClick={() => setShowModal(true)}
          />
        </Col>
      </Row>

      <p className="text-center mt-2" style={{ maxWidth: '750px', fontSize: '1rem', color: '#495057' }}>
        En <strong>Manus Fortis</strong>, ofrecemos una amplia oferta de masajes para satisfacer tus necesidades específicas. Ya sea que busques alivio del dolor, relajación o simplemente un momento para ti, estamos aquí para ayudarte.
      </p>

      {/* Modal de ampliación */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#212529' }}>
            Un lugar apartado y privado
            <small style={{ display: 'block', fontSize: '0.85rem', color: '#6c757d', fontWeight: 'normal', marginTop: '3px' }}>
              Local de Manus Fortis
            </small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center p-0">
          <Image src={sala} alt="Sala" fluid />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default Beneficios;